exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-18a6b896] {\n  background-color: #f8f8f8;\n}", ""]);

// exports
